import { render, staticRenderFns } from "./PostBasicField.vue?vue&type=template&id=56b4fcf4&scoped=true&"
import script from "./PostBasicField.vue?vue&type=script&lang=js&"
export * from "./PostBasicField.vue?vue&type=script&lang=js&"
import style0 from "./PostBasicField.vue?vue&type=style&index=0&id=56b4fcf4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b4fcf4",
  null
  
)

export default component.exports